import { render, staticRenderFns } from "./ReorderSidePanel.vue?vue&type=template&id=6571b2d5&"
import script from "./ReorderSidePanel.vue?vue&type=script&lang=ts&"
export * from "./ReorderSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports